URL
define('models/causes/allocation',['backbone'
   ], function (Backbone) {
       var Allocation = Backbone.Model.extend({
         
        urlRoot: function () {
            var url = pf.consumerURL + "/Allocations";
            return url;
        },
        initialize: function (options) {
            options = options || {};
            this.ID = options.ID;
    
        },
        parse: function (data) {
            var response = {};
            var priority;
            if (data.PR)
                priority = "Yes";
            else
                priority = "No";
            
            response.AllocationID = data.ALID;
            response.AccountID = data.AID;
            response.AccountGUID = data.AGID;
            response.AccountTypeID = data.ATID;
            response.AccountStatusTypeID = data.ASTID;
            response.AccountName = data.AN;
            response.ParentAccountGUID = data.PGID;
            response.AccountOwner = data.AO;
            response.UserID = data.UID;
            response.ManagerUserGUID = data.MUGD
            if (data.ATID == 4) {
                    response.PhotoName = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.MUGD, pf.enums.imageTypeGUIDEnum.Thumbnail, data.PN);
            }
            else {
                response.PhotoName = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.AGID, pf.enums.imageTypeGUIDEnum.Thumbnail, data.PN);
            }
            response.ManagerPhotoName = data.MPN;
            response.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.AGID, pf.enums.imageTypeGUIDEnum.Thumbnail, data.PU);
            response.ManagerPhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.MUGD, pf.enums.imageTypeGUIDEnum.Thumbnail, data.MPU);
            response.AllocationPercentage = data.AP;
            response.TargetDate = data.TD;
            response.TargetAmount = data.TA;
            response.Priority = priority; //data.PR;
            response.CreatedDT = data.CDT;
            response.CreatedByUserID = data.CUID;
            response.LastUpdatedDT = data.LUDT;
            response.LastUpdatedByUserID = data.LUID;
            response.NonContributorTypeID = data.NCID;
            response.NonContributorName = data.NCN;
            response.RowID = data.RID;
             return response;
        },
        save: function (attributes, options) {
            options       = options || {};
            attributes    = attributes || {};;

            var data = {};
           // data.AN = this.attributes.AccountName;
            data.ALID = this.attributes.AllocationID;
            data.AID = this.attributes.AccountID;
            data.ATID = this.attributes.AccountTypeID;
            data.UID = this.attributes.UserID;
            data.AP = this.attributes.AllocationPercentage;
            data.TD = this.attributes.TargetDate;
            data.TA = this.attributes.TargetAmount;
            data.PR = this.attributes.Priority;
            data.CDT = this.attributes.CreatedDT;
            data.CUID = this.attributes.CreatedByUserID;
            data.LUDT = this.attributes.LastUpdatedDT;
            data.LUID = this.attributes.LastUpdatedByUserID;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
       });
       return Allocation;
});

